var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-app",
    { staticClass: "primary-color", attrs: { id: "inspire" } },
    [
      _c(
        "v-content",
        [
          _c(
            "v-layout",
            { attrs: { "align-center": "", "justify-center": "" } },
            [
              _c(
                "v-row",
                {
                  attrs: {
                    xs12: "",
                    sm12: "",
                    md4: "",
                    justify: "space-around"
                  }
                },
                [
                  _c(
                    "v-card",
                    {
                      staticClass: "login-card primary-color",
                      attrs: { width: "100%", "max-width": "400px" }
                    },
                    [
                      _c("v-row", {
                        attrs: { align: "center", justify: "center" }
                      }),
                      _c(
                        "v-toolbar",
                        { attrs: { color: "toolbarBase", dark: "", flat: "" } },
                        [
                          _c("v-toolbar-title", [_vm._v("Login")]),
                          _c("v-spacer"),
                          _c("v-tooltip", { attrs: { right: "" } }, [void 0], 2)
                        ],
                        1
                      ),
                      _c(
                        "v-card-text",
                        [
                          _c(
                            "v-form",
                            {
                              ref: "form",
                              model: {
                                value: _vm.valid,
                                callback: function($$v) {
                                  _vm.valid = $$v
                                },
                                expression: "valid"
                              }
                            },
                            [
                              !_vm.identifierVoter
                                ? _c(
                                    "v-row",
                                    [
                                      _c("v-select", {
                                        attrs: {
                                          "prepend-icon": "search",
                                          items: _vm.identifiers,
                                          label:
                                            "Selecione o tipo autenticação",
                                          readonly: _vm.locked,
                                          rules: [
                                            _vm.selectIdentifierNotSelected
                                          ],
                                          dense: ""
                                        },
                                        on: {
                                          change: function($event) {
                                            return _vm.onChange($event)
                                          }
                                        },
                                        model: {
                                          value: _vm.typeIdentifier,
                                          callback: function($$v) {
                                            _vm.typeIdentifier = $$v
                                          },
                                          expression: "typeIdentifier"
                                        }
                                      }),
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12" } },
                                        [
                                          _c(
                                            "v-alert",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value: _vm.electionMessage,
                                                  expression: "electionMessage"
                                                }
                                              ],
                                              staticClass: "login-nopass-alert",
                                              attrs: {
                                                border: "left",
                                                "close-text": "Fechar alerta",
                                                dismissible: "",
                                                "max-width": "400px"
                                              },
                                              model: {
                                                value: _vm.alert,
                                                callback: function($$v) {
                                                  _vm.alert = $$v
                                                },
                                                expression: "alert"
                                              }
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "subtitle-2" },
                                                [
                                                  _vm._v(
                                                    _vm._s(_vm.electionMessage)
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      ),
                                      _c("v-text-field", {
                                        attrs: {
                                          "prepend-icon": "lock",
                                          label: _vm.identifierDescripttion,
                                          name: "identifier",
                                          id: "identifier",
                                          rules: [_vm.validateIdentifier],
                                          required: "",
                                          clearable: ""
                                        },
                                        on: {
                                          keypress: function($event) {
                                            return _vm.isNumber($event)
                                          }
                                        },
                                        model: {
                                          value: _vm.identifier,
                                          callback: function($$v) {
                                            _vm.identifier = $$v
                                          },
                                          expression: "identifier"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.identifierVoter
                                ? _c(
                                    "v-row",
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          label: "Eleitor",
                                          disabled: ""
                                        },
                                        model: {
                                          value: _vm.nameVoter,
                                          callback: function($$v) {
                                            _vm.nameVoter = $$v
                                          },
                                          expression: "nameVoter"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _c("ValidatePersonalData", { ref: "validatePD" }),
                              _c("InformPassword", { ref: "informPassword" }),
                              _c("ValidateRecaptcha", { ref: "validateR" })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "v-card-actions",
                        [
                          _c("v-spacer"),
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                color: "toolbarBase white--text",
                                tile: "",
                                block: "",
                                type: "submit"
                              },
                              on: { click: _vm.signin }
                            },
                            [_vm._v("Acessar")]
                          )
                        ],
                        1
                      ),
                      _c(
                        "v-card-actions",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.resetPassword,
                              expression: "resetPassword"
                            }
                          ]
                        },
                        [
                          _c("v-spacer"),
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                tile: "",
                                block: "",
                                type: "button",
                                color: "toolbarBase",
                                outlined: ""
                              },
                              on: { click: _vm.passwordReset }
                            },
                            [_vm._v(" Redefinir senha ")]
                          )
                        ],
                        1
                      ),
                      _c(
                        "p",
                        {
                          staticStyle: {
                            "font-size": "10px",
                            "margin-left": "5%",
                            "margin-right": "5%"
                          }
                        },
                        [
                          _vm._v(
                            " Este site é protegido pelo reCAPTCHA e pelas "
                          ),
                          _c(
                            "a",
                            {
                              attrs: {
                                href: "https://policies.google.com/privacy"
                              }
                            },
                            [_vm._v("Políticas de Privacidade")]
                          ),
                          _vm._v(" e "),
                          _c(
                            "a",
                            {
                              attrs: {
                                href: "https://policies.google.com/terms"
                              }
                            },
                            [_vm._v("Termos de Serviço")]
                          ),
                          _vm._v(" do Google. ")
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }